// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import ServiceRequest from "./pages/ServiceRequest";
import MonitoringManager from "./pages/MonitoringManager";
import ApplicationTable from "./components/ApplicationTable";
import ApplicationDetails from "./components/ApplicationDetails";
import AnalysisResultTabs from "./pages/AnalysisResultTabs";
import WebFrameDashboard from "./pages/WebFrameDashboard";
import ClusterDiagram from "./components/ClusterDiagram";
import KentyouHome from "./pages/KentyouHome";
import KentyouDashboard from "./pages/KentyouDashboard";
import MapView from "./pages/MapView";
import clusterData from "./data/nodes.json";

import PrivateRoute from "./auth/PrivateRoute";
import TestbedGate from "./auth/TestbedGate";
//import ChooseTestbed from "./pages/ChooseTestbed";
import { keycloak } from "./auth/keycloak";
import KentyouAggregations from "./pages/KentyouAggregations";
import { resolveTestbedFromGroups } from "./auth/groupToTestbed";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTestbed } from "./slices/testbedSlice";

import "antd/dist/reset.css";
import "./index.css";

function RootRedirect() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const groups = keycloak.tokenParsed?.groups || [];
    const tbs = resolveTestbedFromGroups(groups); // [] | ['tbA'] | ['tbB'] | ['tbA','tbB']

    if (tbs.length === 1) {
      // INTRA/TMA: auto-pick, same as before
      dispatch(setTestbed(tbs[0]));
    }
    // Admin (both) → do NOT set here; they choose via navbar
    // None → TestbedGate will show a warning

    navigate("/home", { replace: true });
  }, [dispatch, navigate]);

  return null;
}

const AppContent = () => {
  const location = useLocation();

  const withAuthAndTb = (el, roles) => (
    <PrivateRoute roles={roles}>
      <TestbedGate>{el}</TestbedGate>
    </PrivateRoute>
  );

  return (
    <div>
       <Navbar />
      <Sidebar />

      <div className="content">
        <Routes>
          {/* Root decides based on group count */}
          <Route path="/" element={<PrivateRoute><RootRedirect /></PrivateRoute>} />

          {/* Choose-testbed requires auth but not TestbedGate */}
          

          {/* Home can be direct (optional wrap with TestbedGate if you want a chosen testbed) */}
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />

          {/* Protected routes that also require a selected testbed */}
          <Route path="/dashboard" element={withAuthAndTb(<Dashboard />)} />
          <Route path="/service-request" element={withAuthAndTb(<ServiceRequest />)} />
          <Route path="/monitoring-manager" element={withAuthAndTb(<MonitoringManager />)} />
          <Route path="/applications" element={withAuthAndTb(<ApplicationTable />)} />
          <Route path="/applications/:applicationId" element={withAuthAndTb(<ApplicationDetails />)} />
          <Route path="/analysis-results/:applicationId" element={withAuthAndTb(<AnalysisResultTabs />)} />
          <Route path="/data-visualisations" element={withAuthAndTb(<WebFrameDashboard />)} />
          <Route path="/cluster-diagram" element={withAuthAndTb(<ClusterDiagram data={clusterData} />)} />
          <Route path="/kentyouhome" element={withAuthAndTb(<KentyouHome />)} />
          <Route path="/kentyoudashboard" element={withAuthAndTb(<KentyouDashboard />)} />
          <Route path="/map" element={withAuthAndTb(<MapView />)} />
          <Route path="/kentyoueye" element={withAuthAndTb(<KentyouAggregations />)} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
